import { Row, DatePicker } from "antd";
import { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;

type PeriodSelectorProps = {
  range: [Dayjs, Dayjs];
  onPeriodChange: (data: any) => void;
};

export const PeriodSelector = ({
  range,
  onPeriodChange,
}: PeriodSelectorProps) => {
  return (
    <Row className="align-center">
      Period
      <RangePicker
        className="ml-2 period-selector"
        picker="year"
        value={range}
        onChange={onPeriodChange}
        allowClear={false}
      />
    </Row>
  );
};
